import { Platform, StyleSheet } from 'react-native';

import { initialWindowMetrics } from 'react-native-safe-area-context';

import { isAndroid15 } from 'utils/responsiveness';

const styles = StyleSheet.create({
    container: {
        paddingTop: 0,
        paddingRight: Platform.select({ default: 0, web: 40 }),
    },
    logo: {
        paddingTop: isAndroid15 ? initialWindowMetrics?.insets.top : 0,
        justifyContent: 'center',
        width: 49,
        height: 24,
    },
    logoWithoutInsets: {
        paddingTop: 0,
    },
});

export default styles;
